import React from "react"
import { StyledSectionContainer } from "src/components/common/StyledSectionContainer"
import styled from "styled-components"

const list = [
  {
    name: "BKFC",
    image:
      "https://assets-imgx.fubo.tv/marketing/lp/images/fsn/shows/2025/BKFC_KeyArt_Ntwk_Series_3x4.jpg?ch=width&auto=format,compress",
  },
  {
    name: "Glory Kickboxing",
    image:
      "https://assets-imgx.fubo.tv/marketing/lp/images/fsn/shows/2025/Glory_KeyArt_Ntwk_Series_3x4.jpg?ch=width&auto=format,compress",
  },
  {
    name: "Bellator",
    image:
      "https://assets-imgx.fubo.tv/marketing/lp/images/fsn/shows/2026/Bellator_KeyArt_Ntwk_Series_3x4.jpg?ch=width&auto=format,compress",
  },
  {
    name: "Nations League",
    image:
      "https://assets-imgx.fubo.tv/marketing/lp/images/fsn/shows/2026/NationsLeague_KeyArt_Ntwk_Series_3x4.jpg?ch=width&auto=format,compress",
  },
  {
    name: "Grand Sumo",
    image:
      "https://assets-imgx.fubo.tv/marketing/lp/images/fsn/shows/2025/GrandSumo_KeyArt_Ntwk_Series_3x4.jpg?ch=width&auto=format,compress",
  },
  {
    name: "EFA",
    image:
      "https://assets-imgx.fubo.tv/marketing/lp/images/fsn/shows/2026/EFA_KeyArt_Ntwk_Series_3x4.jpg?ch=width&auto=format,compress",
  },
  {
    name: "Hoops HQ",
    image:
      "https://assets-imgx.fubo.tv/marketing/lp/images/fsn/shows/2026/HoopsHQ_KeyArt_Ntwk_Series_3x4.jpg?ch=width&auto=format,compress",
  },
  {
    name: "Fantasy Life",
    image:
      "https://assets-imgx.fubo.tv/marketing/lp/images/fsn/shows/2026/FantasyLife_KeyArt_Ntwk_Series_3x4.png?ch=width&auto=format,compress",
  },
]

const ShowsSection = () => {
  return (
    <StyledShowsSection>
      <h2>Top Programming</h2>
      <div className="shows-section">
        {list.map((item, index) => (
          <div className="image" key={index}>
            <img src={item.image} alt={item.name} />
          </div>
        ))}
      </div>
    </StyledShowsSection>
  )
}

export default ShowsSection

const StyledShowsSection = styled(StyledSectionContainer)`
  background: #000;
  color: #fff;
  position: relative;
  padding-left: 60px;
  padding-right: 60px;
  @media (max-width: 768px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  &::before {
    width: 100%;
    height: 100%;
    content: "";
    position: absolute;
    background: radial-gradient(#fff, transparent 70%);
    opacity: 0.35;
  }
  > * {
    z-index: 1;
  }
  h2 {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    span {
      img {
        display: inline-block;
        width: 60px;
      }
    }
  }
  .shows-section {
    max-width: 1200px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 20px;
    .image {
      flex: 0 0 calc((100% - 60px) / 4);
      border-radius: 10px;
      overflow: hidden;
      img {
        width: 100%;
        display: block;
      }
    }
    @media (max-width: 900px) {
      .image {
        flex: 0 0 calc((100% - 40px) / 3);
      }
    }
    @media (max-width: 600px) {
      .image {
        flex: 0 0 calc((100% - 20px) / 2);
      }
    }
  }
  p {
    color: #a7aaaa;
  }
`
